import React from 'react';

export default class MinimalResumePersonalInformation extends React.Component {
    render() {
        return  <div  data-v-b8233322="" className="section">
                    { this.props.data.name && <div data-v-b8233322="" className="section-name">{this.props.data.name}</div>}
                    { this.props.data.profession && <div data-v-b8233322="" className="section-title">{this.props.data.profession}</div>}
                    { this.props.data.website && <div data-v-b8233322="" className="section-contact" >{this.props.data.website}</div>}
                    { this.props.data.address && <div  data-v-b8233322="" className="section-contact">{this.props.data.address}</div>}
                    { this.props.data.email && <div data-v-b8233322="" className="section-contact">{this.props.data.email}</div>}
                    { this.props.data.phone && <div  data-v-b8233322="" className="section-contact">{this.props.data.phone}</div>}
                </div>
    }
}